import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import NONEICON from "../../images/NoneIcon.svg";
import GENERALICON from "../../images/generalcon.svg";
import BIRTHDAYICON from "../../images/birthdayIconTemp.svg";
import CHRISTMASICON from "../../images/christmasIcon.svg";
import EASTERICON from "../../images/easterIcon.svg";
import EDUCATIONICON from "../../images/educationIconTemp.svg";
import FAREWELLICON from "../../images/farewelcon.svg";
import HOBBIESICON from "../../images/hobbiesIcon.svg";
import ANNIVERSARY from "../../images/AnniversaryIcon.svg"
import NONEACTIVE from "../../images/NoneActive.svg";
import GENERALACTIVE from "../../images/generalIconActive.svg";
import BIRTHDAYACTIVE from "../../images/birthdayIconActive.svg";
import CHRISTMASACTIVE from "../../images/christmasIconActive.svg";
import EASTERACTIVE from "../../images/easterIconActive.svg";
import EDUCATIONACTIVE from "../../images/educationIconActive.svg";
import FAREWELLACTIVE from "../../images/farewellIconActive.svg";
import HOBBIESACTIVE from "../../images/hobbiesIconActive.svg";
import ANNIVERSARYACTIVE from "../../images/AnniversaryIcon_active.svg";
import RightArrow from "../../images/icon_right_arrow.svg";
import LeftArrow from "../../images/icon_left_arrow.svg";
import AppStyles from "../../config/styles";
import "../../styles/ConnectScreen.css";
import {
  TemplateListContainer,
  TemplateRightDiv, TempIcon,
  TempIcondiv
} from "../atoms/ConnectStories";
import { gaEvent } from "../../utilities/analytics";
import { isMobile } from "../../utilities/deviceUtilities";

function TemplateModal(props) {

  const { t } = useTranslation();
  const { persistItemsReducer } = useSelector((state) => state);
  const [templateList, setTemplateList] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [filteredIconData, setFilteredIconData] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const isFarewell = props?.isCelebrationChild;

  const chunkArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  const slides = chunkArray(filteredIconData || [], 3);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const handleAddBtn = () => {
    gaEvent("AddBtnChooseTemplatePopup", persistItemsReducer);
  }

  const styles = {
    horizontalBarStyles: {
      alignSelf: "center",
      backgroundColor: AppStyles.colors.COLOR_GREYE6,
    },
    imgStyles: {
      alignSelf: "center",
      marginVertical: "20px",
    },
    headerTextStyles: {
      fontFamily: "Lato",
      fontSize: "24px",
      color: "rgba(0,0,0,1)",
      textAlign: "center",
    },
    contentTextStyles: {
      fontFamily: "Lato",
      fontSize: "16px",
      color: "rgba(17,17,17,1)",
      marginVertical: "20px",
      paddingHorizontal: "20px",
      textAlign: "center",
    },
    listStyles: {
      height: "200px",
      marginBottom: "25px",
    },
    itemViewStyles: {
      display: "flex",
      backgroundColor: "transparent",
      textAlign: "left",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    itemContentStyles: {
      padding: "0px 3px",
    },
    titleStyles: {
      fontSize: "14px",
      color: "rgba(51,51,51,1)",
      width: "15ch",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      textAlign: "center"
    },
    btnLabelStyles: {
      color: "rgba(255,255,255,1)",
      fontFamily: "Lato-Bold",
      fontSize: "20px",
    },
  };

  const data = [
    {
      id: 1,
      artifactCode: "OCN_NONE",
      icon: <img src={NONEICON} alt="" />,
      selectedIcon: <img src={NONEACTIVE} alt="" />,
      title: `${t("None")}`,
    },
    {
      id: 2,
      artifactCode: "OCN_GENERAL",
      icon: <img src={GENERALICON} alt="" />,
      selectedIcon: <img src={GENERALACTIVE} alt="" />,
      title: `${t("General")}`,
    },
    {
      id: 3,
      artifactCode: "OCN_BIRTHDAY",
      icon: <img src={BIRTHDAYICON} alt="" />,
      selectedIcon: <img src={BIRTHDAYACTIVE} alt="" />,
      title: `${t("Birthday")}`,
    },
    {
      id: 4,
      artifactCode: "OCN_CHRISTMAS",
      icon: <img src={CHRISTMASICON} alt="" />,
      selectedIcon: <img src={CHRISTMASACTIVE} alt="" />,
      title: `${t("Christmas")}`,
    },
    {
      id: 5,
      artifactCode: "OCN_FAREWELL",
      icon: <img src={FAREWELLICON} alt="" />,
      selectedIcon: <img src={FAREWELLACTIVE} alt="" />,
      title: `${t("Farewell")}`,
    },
    {
      id: 6,
      artifactCode: "OCN_HOBBIES",
      icon: <img src={HOBBIESICON} alt="" />,
      selectedIcon: <img src={HOBBIESACTIVE} alt="" />,
      title: `${t("Hobbies")}`,
    },
    {
      id: 7,
      artifactCode: "OCN_EDUCATION",
      icon: <img src={EDUCATIONICON} alt="" />,
      selectedIcon: <img src={EDUCATIONACTIVE} alt="" />,
      title: `${t("Education")}`,
    },
    {
      id: 8,
      artifactCode: "OCN_EASTER",
      icon: <img src={EASTERICON} alt="" />,
      selectedIcon: <img src={EASTERACTIVE} alt="" />,
      title: `${t("Easter")}`,
    },
    {
      id: 9,
      artifactCode: "OCN_ANNIVERSARY",
      icon: <img src={ANNIVERSARY} alt="" />,
      selectedIcon: <img src={ANNIVERSARYACTIVE} alt="" />,
      title: `${t("Easter")}`,
    },
  ];

  useEffect(() => {
    let result = props?.recipientsList && props?.recipientsList.length > 0 ? props?.recipientsList.map(item => item?.childCode.split("-")[1]) : []

    if (props?.templatesData && props?.templatesData?.length > 0) {
      setTemplateList(props?.templatesData?.filter(templatesData => !result.find((value) => templatesData?.projectNumbersToHide.split(",").includes(value))));
      setSelectedTemplate(props?.isDateEqualandAfter ? null : (props?.draftselectedTemplate || ""));
    }
  }, [props?.templatesData, props?.draftselectedTemplate, props?.recipientsList]);

  const filterIconData = templateList?.map((item) => {
    const tempItem = data?.find((temp) => temp.artifactCode === item.artifactCode);
    if (tempItem) {
      return {
        ...tempItem,
        title: item.title,
        body: item.body,
      };
    }
    return item;
  });

  useEffect(() => {
    if (templateList?.length > 0) {
      const result = filterIconData;
      setFilteredIconData(result);
    }
  }, [templateList]);

  const handleIconClick = (item) => {
    let template = templateList
      .find((templateData) => templateData?.artifactCode == item?.artifactCode);
    if (template?.artifactCode == selectedTemplate?.artifactCode) {
      template = templateList
        .find((templateData) => templateData?.artifactCode == "OCN_NONE");
    }
    setSelectedTemplate(props?.draftselectedTemplate ? props?.draftselectedTemplate : props?.templatesData[0]);
    props?.addTemplate(template); handleAddBtn()
  };
  const isChristmasSeason=() =>{
    const now = new Date(); // 2025-12-15
    const year = now.getFullYear();
    const start = new Date(`${year}-11-01`);
    const end = new Date(`${year + 1}-01-06`);
  
    // If current date is in November or December
    if (now >= start && now <= new Date(`${year}-12-31`)) {
      return true;
    }
  
    // If current date is in January and before Jan 6
    if (now >= new Date(`${year + 1}-01-01`) && now <= end) {
      return true;
    }
  
    return false;
  }
  const isEasterSeason=()=> {
    const date = new Date();
    const year = date.getFullYear();
  
    const start = new Date(`${year}-03-01`);
    const end = new Date(`${year}-04-30`);
  
    return date >= start && date <= end;
  }
  const renderIcons = (item) => {
    if((item.artifactCode == "OCN_CHRISTMAS" && !isChristmasSeason() ) 
      || (item.artifactCode === "OCN_EASTER" && !isEasterSeason())
      || (item.artifactCode === "OCN_ANNIVERSARY" && props?.anniversaryNumber == "0")){
      return null
    }else{
      return(
        <button
          onClick={() => handleIconClick(item)}
          style={styles.itemViewStyles}
        >
          <TempIcon
            onClick={() => handleIconClick(item)}
            key={item?.artifactCode}
          >{(item?.artifactCode === selectedTemplate?.artifactCode) ? item.selectedIcon : item.icon}</TempIcon>
          <div style={styles.itemContentStyles}>
            <div style={styles.titleStyles}>{item.title}</div>
          </div>
        </button>
        )
    }
   
  };

 return (
  <TemplateRightDiv>
    {isMobile(750) ? (
      <div className="custom-slider-wrapper">
        <button className="slider-arrow left" onClick={prevSlide}>
          <img src={LeftArrow} alt="leftArrow" />
        </button>
        <div className="custom-slider">
          {slides[currentSlide]
            ?.filter(item => isFarewell || item.artifactCode !== "OCN_FAREWELL")
            .map((item, index) => (
              <div key={index} className="icon-wrapper">
                {renderIcons(item)}
              </div>
            ))}
        </div>
        <button className="slider-arrow right" onClick={nextSlide}>
          <img src={RightArrow} alt="rightArrow" />
        </button>
      </div>
    ) : (
      <TemplateListContainer style={{ overflowX: "auto" }} className="template-list-container">
        <TempIcondiv>
          {filteredIconData?.length > 0 &&
            filteredIconData
              .filter(item => isFarewell || item.artifactCode !== "OCN_FAREWELL")
              .map(item => renderIcons(item))
          }
        </TempIcondiv>
      </TemplateListContainer>
    )}
  </TemplateRightDiv>
);

}

export default TemplateModal;
